<template>
  <b-overlay id="overlay-background" class="overlay-config kpi-main" :show="loading" rounded="sm" >    
    <PageTitle main="Configuração dos Indicadores"  sub=""  imagem="Planejamento.png" />
    <b-card-body class="context-main">
      <p v-if="wait && params.data.length < 2">{{ $t('aguardando-dados-das-configuracoes-dos-indicadores') }}</p>
      <span :class="{ 'filter-kpi': true, 'hide': wait && params.data.length < 2 }">
        <label for="filter-kpi">Filtro: </label>
            <input
              type="text"
              name="filter-kpi"
              class="ml-1 input-pentagro"
              v-model="gridFilter"
            />
      </span>
      <div id="indicator-table" :class="{ 'table-kpi': true, 'hide': wait && params.data.length < 2}"></div>
    </b-card-body>

    <div>
      <b-row class="groupBtn">
          <div>
            <img
              v-b-modal.restoreTree
              v-if="!wait"
              src="@/assets/mostrarHistoricoAcoes.png"
              :alt="$t('mostrar-historico')"
              style="margin-left: 30px;"
              :title="$t('restaurar-versoes-da-configuracao-de-indicadores')"
            />
            <img
              v-if="!wait"
              src="@/assets/atualizar.png"
              style="margin-left: 30px;"
              :title="$t('limpar')"
              alt="limpar"
              @click="resetTable"
            />
            <img
              v-if="!wait"
              src="@/assets/salvar.png"
              :alt="$t('verificar-arvore')"
              style="margin-left: 35px;"
              :title="$t('verificar-erros-da-arvore-e-salvar')"
              @click="checkKpiTree"
            />
          </div>
      </b-row>
    </div>

    <b-modal
      id="askSaveKPIs"
      size="md"
      hide-footer
      :title="$t('atention')"
      :no-close-on-backdrop="true"
    >
      <MessageBox
        :question="$t('deseja-salvar-as-configuracoes-dos-indicadores')"
        v-bind:action="saveKPI"
        modelname="askSaveKPIs"
      />
    </b-modal>

        <b-modal
      id="showProductPlainItem"
      size="md"
      hide-footer
      :title="$t('selecione-uma-variavel-do-plano-de-safra')"
      :no-close-on-backdrop="true"
    >
    <SelectProductPlainItem
      :getItemSelected="productPlainItemSelected[this.field]"
      @productSelected="setProductPlainItem"
     />
    </b-modal>
    
    <b-modal
      id="showListGreatness"
      size="md"
      hide-footer
      :title="$t('selecione-uma-grandeza')"
      :no-close-on-backdrop="true"
    >
    <SelectGreatness
      :getItemSelected="productPlainItemSelected[this.field]"
      @greatnessSelected="setProductPlainItem"
    />
    </b-modal>

    <b-modal
      id="restoreTree"
      hide-footer
      size="md"
      :no-close-on-backdrop="true"
      :title="$t('restaurar-arvore-de-indicadores')">
      <RestoureIndicatorConfiguration 
        :loadIndicators="loadIndicators"
        @loadIndicators="loadIndicators=$event"
      />
    </b-modal>

  </b-overlay>
</template>

<script>
  import * as cheetahGrid from "cheetah-grid";
  import { urlMainAPI, defaultSuccess, showError } from "@/global";
  import PageTitle from "../template/PageTitle";
  import axios from "axios";
  import MessageBox from "../template/MessageBoxModal.vue";
  import { WaitMixin } from "../mixins/waitMixin"
  import TableKPIConfig from "./TableKPIConfig"
  import SelectProductPlainItem from "./SelectProductPlainItem"
  import RestoureIndicatorConfiguration from "./kpiConfigurationBackup/RestoureIndicatorConfiguration.vue";
  import SelectGreatness from "./SelectGreatness.vue";

  var gridKpiConf;

  export default {
    name:"KpiConfiguration",

    components: { PageTitle, MessageBox, SelectProductPlainItem, RestoureIndicatorConfiguration, SelectGreatness },

    mixins: [ WaitMixin ],

    data() {
      return {
        invalidNumbers: [-9999, '-9999', -9998, '-9998'],
        mapKeys: [],
        gridFilter: "",
        params: {
          header: TableKPIConfig.Header,
          data: [],
          dataBkp: [],
          dataToSave: [],
        }, 
        productPlainItemSelected:{},
        listIndicatorConfigurationBackup : [],
        loadIndicators: -9999,
        loading: false, 
        field: "",
      }
    },

    watch:{
      async loadIndicators() {
        await this.loadIndicatorConfiguration();
        this.setGrid();
      }
    },

    methods: {
      setProductPlainItem(value){
          this.productPlainItemSelected[this.field] = value 
      },
      
      async loadIndicatorConfiguration(){
        const url = `${urlMainAPI}/getindicatorconfiguration`
        this.wait = true;

        await axios.get(url).then(res => {
          this.params.data = res.data.map(d => this.parseLine(d))
          this.params.dataBkp = JSON.parse(JSON.stringify(res.data));
          this.wait = false;
        }).catch(e => {console.log(e); this.wait = false})
      },

      parseLine(data) {
        return {
          ...data,
          target: this.invalidNumbers.includes(data.target) ? null : this.parseNumber(data.target),
          operationalRange: this.parseNumber(data.operationalRange) == 0 ? (!data.signal ? 0 : "0") : this.parseNumber(data.operationalRange),
          criticalRange: this.parseNumber(data.criticalRange) == 0 ? (!data.signal ? 0 : "0") : this.parseNumber(data.criticalRange),
          reabilityThreshold: this.parseNumber(data.reabilityThreshold) == 0 ? "0" : this.parseNumber(data.reabilityThreshold),
          criticReabilityThreshold: this.parseNumber(data.criticReabilityThreshold) == 0 ? "0" : this.parseNumber(data.criticReabilityThreshold),
          delay: this.parseNumber(data.delay) == 0 ? "0" : this.parseNumber(data.delay),
          analysis: this.parseNumber(data.analysis) == 0 ? "0" : this.parseNumber(data.analysis),
          weigth: this.parseNumber(data.weigth) == 0 ? "0" : this.parseNumber(data.weigth),
          indicatorPlan: data.indicatorPlan,
          closingTypeCalculation : data.closingTypeCalculation,
          indicatorPlanBI: data.indicatorPlanBI,
        }
      },

      async createGrid() {
        gridKpiConf = new cheetahGrid.ListGrid({
          parentElement: document.querySelector(".table-kpi"),
          allowRangePaste: true,
          header: this.params.header,
          defaultColWidth: 100
        });
      },

      past(args){
        let lines = args.value.split("\r\n");
          if (args.row != 1) return;
          this.params.data = new Array();

          for (let i = 0; i <= lines.length; i++) {
            this.addLine(lines[i]);
          }

          this.params.data.sort((i, j) => {
            let id1 = parseInt(i.id)
            let id2 = parseInt(j.id)

            if(id1 > id2)
              return 1
            if(id1 < id2)
              return -1
            return 0
          })

          this.setGrid();
          defaultSuccess(this.$t('configuracoes-inseridas'))
      },

      addLine(param) {
        if(!param) return;
        let columns = param.split('\t')

        let d = this.mapKeys[columns[0] - 1]
        if(!d) return;
      
        this.params.data.push({
          indicatorId: d.indicatorId,
          productionUnitId: d.productionUnitId,
          system: d.system,
          id: columns[0],
          indicator: columns[1],
          signal: columns[2] == this.$t('grupo') ? '' : columns[2] == "LIE e LSE" ? "=" : columns[2] == 'LIE' ? "<" : ">",
          operationalRange: this.parseNumber(columns[3]) == 0 ? "0.00" : this.parseNumber(columns[3]),
          criticalRange: this.parseNumber(columns[4]) == 0 ? "0.00" : this.parseNumber(columns[4]),
          reabilityThreshold: this.parseNumber(columns[5]) == 0 ? "0.00" : this.parseNumber(columns[5]),
          criticReabilityThreshold: this.parseNumber(columns[6]) == 0 ? "0.00" : this.parseNumber(columns[6]),
          target: this.invalidNumbers.includes(columns[7]) ? null : this.parseNumber(columns[7]),
          delay: this.parseNumber(columns[8]) == 0 ? "0.00" : this.parseNumber(columns[8]),
          analysis: this.parseNumber(columns[9]) == 0 ? "0.00" : this.parseNumber(columns[9]),
          weigth: this.parseNumber(columns[10]) == 0 ? "0.00" : this.parseNumber(columns[10]),
          type: columns[11] == this.$t('analitico') ? 
                'analitico' : 
                columns[11] == this.$t('online') ?
                'online' : 
                columns[11] == this.$t('diario') ?
                'diario' :
                'diario',
          indicatorPlan: columns[12],
          indicatorPlanBI: columns[13]
        });
      },

      async setGrid(table = this.params.data) {
        this.mapKeys = table.map(i => ({
          indicatorId: i.indicatorId,
          productionUnitId: i.productionUnitId,
          system: i.system,
            indicator: i.indicator
        }));

        let filterData = await table.map((t, i) => ({...t, id: i+1}));
        let filterKpiDataSource = new cheetahGrid.data.CachedDataSource({
          get(index){ return filterData[index]; },
          length: filterData.length,
        });

        setTimeout(() => {
          filterKpiData = new cheetahGrid.data.FilterDataSource(filterKpiDataSource);
          gridKpiConf.dataSource = filterKpiData;
        }, 400)
      },
      
      async checkKpiTree(){
        await this.clearFilter()
        this.wait = true;
        defaultSuccess(this.$t('verificando-a-estrutura-da-arvore'));
        let listToSave = new Array()
        let countLines = gridKpiConf.dataSource.length
        let errorNumber = 0;

        for(let i = 0; i < countLines; i++){
          let kpi = gridKpiConf.dataSource.source.get(i);
          let d = this.mapKeys[kpi.id - 1]

          if(this.isNotNumber(kpi)){
            errorNumber = i+1
            break;
          }

          listToSave.push({
            ...kpi,
            target: kpi.target || kpi.target == 0 ? this.parseNumber(kpi.target) : -9999,
            operationalRange: this.parseNumber(kpi.operationalRange),
            criticalRange: this.parseNumber(kpi.criticalRange),
            criticReabilityThreshold: this.parseNumber(kpi.criticReabilityThreshold),
            reabilityThreshold: this.parseNumber(kpi.reabilityThreshold),
            indicatorId: d.indicatorId,
            productionUnitId: d.productionUnitId,
            system: d.system,
            delay: this.parseNumber(kpi.delay),
            analysis: this.parseNumber(kpi.analysis),
            weigth: this.parseNumber(kpi.weigth),
            indicatorPlan: kpi.indicatorPlan,
            indicatorPlanBI: kpi.indicatorPlanBI,
          })
        }

        if(errorNumber){
          showError(this.$t('ha-letras-onde-deveria-ser-numero-linha') + errorNumber)
          this.wait = false;
          return;
        }

        let data = [listToSave, this.params.dataBkp]

        const url = `${urlMainAPI}/checkVwIndicatorConfiguration`
        axios.post(url, data)
          .then(res => {
            if(res.status == 200)
            {
              defaultSuccess(res.data); 
              this.$bvModal.show("askSaveKPIs");
              this.params.dataToSave = listToSave;
            }
            else
            {
              showError(res.data)
            }
              this.wait = false
          }).catch(e => {
            console.log(e); 
            this.wait = false;
          })
      },
      
      clearFilter(){
        return new Promise(resolve => {
          this.gridFilter = ""
          filterKpiData.filter =  null;
            setTimeout(resolve, 200);
          }
        )
      },

      isNotNumber(rec){
        return  (isNaN(parseFloat(rec.operationalRange)) ||
                isNaN(parseFloat(rec.criticalRange)) ||
                isNaN(parseFloat(rec.reabilityThreshold)) ||
                isNaN(parseFloat(rec.criticReabilityThreshold)) ||
                ((isNaN(parseFloat(rec.delay)) && rec.delay != null) && rec.delay != '') ||
                ((isNaN(parseFloat(rec.analysis)) && rec.analysis != null) && rec.analysis != '') ||
                isNaN(parseFloat(rec.weigth)))
      },

      saveKPI(){
        const url = `${urlMainAPI}/saveindicatorconfiguration`
        defaultSuccess(this.$t('salvando-configuracao-de-indicadores'));
        this.wait = true;
        let data = this.params.dataToSave

        axios.post(url, data)
          .then(async res => {
            defaultSuccess(res.data); 
            this.saveKpiBackup(data)
            this.wait = false
            
            await this.loadIndicatorConfiguration();
            this.setGrid();
          })
          .catch(e => {console.log(e); this.wait = false})
      },

      saveKpiBackup(data){
        const url = `${urlMainAPI}/saveindicatorconfigurationbackup`
        defaultSuccess(this.$t('salvando-backup-dos-indicadores'));
        this.wait = true;

        axios.post(url, data)
          .then(res => {
            defaultSuccess(res.data); 
            this.wait = false
          })
          .catch(e => {console.log(e); this.wait = false})
      },

      async resetTable(){
        this.params.data = JSON.parse(JSON.stringify(this.params.dataBkp.map( d => ({...d, target: this.invalidNumbers.includes(d.target) ? null : this.parseNumber(d.target) }))));
        await this.setGrid()
        defaultSuccess(this.$t('configuracao-de-indicadores-recarregadas'));
      },

      parseNumber(num){
        try {
          let number = parseFloat(String(num).replace(",", '.'))
          return !number ? 0 : number
        }
        catch (e)
        { 
          return 0.00 
        }
      },

      setFilter() {
        const input = document.querySelector('.filter-kpi>input');
        input.addEventListener('input', () => {
          const filterValue = input.value;
          filterKpiData.filter = filterValue ? (record) => {
            for (const k in record) {
              if ((`${record[k]}`).toUpperCase().includes(filterValue.toUpperCase())) {
                return true;
              }
            }
            return false;
          } : null;
          gridKpiConf.invalidate();
        });
      },
    },

    async mounted() {
      this.loading = true;
      defaultSuccess(this.$t('carregando-configuracao-de-indicadores'));
      await this.loadIndicatorConfiguration();
      defaultSuccess(this.$t('configuracao-de-indicadores-carregadas'));
      this.createGrid();
      this.setFilter()
      this.setGrid();
      TableKPIConfig.gridKpiModal =(rec, field) =>{
        this.productPlainItemSelected = rec
        this.field = field
        this.$bvModal.show('showProductPlainItem')
      },
      TableKPIConfig.showModalGreatness =(rec, field) =>{
        this.productPlainItemSelected = rec
        this.field = field
        this.$bvModal.show("showListGreatness")
      } 
      this.loading = false;
    },

    destroyed() { this.wait = false },
  }

  var filterKpiData = [];

</script>

<style>
.table-kpi > .cheetah-grid>canvas {
  height: 100%;
  width: 100%;
  box-shadow: 0 0 4px #0008;
  border-radius: 4px;
}
</style>

<style scoped>

.context-main {
  overflow: hidden;
  padding: 8px;
  height: calc(66vh - 30px);
}

.hide {
  display: none;
}

.table-kpi {
  width: 100%;
  height: calc(100% - 30px);
  box-shadow: 0 0 3px #0006;
}

.groupBtn {
  display: flex;
  justify-content: flex-end;
  margin: 25px 5px 0 0;
}

@media (min-height: 760px) {
  .context-main {
    height: calc(68vh - 30px);
  }
}

@media (min-height: 900px) {
  .context-main {
    height: calc(74vh - 30px);
  }
}

@media (min-height: 1050px) {
  .context-main {
    height: calc(77vh - 30px);
  }
}

@media (max-width: 1160px) {
  .context-main {
    height: calc(55vh - 30px);
  }
}

@media (min-height: 1600px) {
  .context-main {
    height: calc(84vh - 30px);
  }
}
</style>